import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//Icon
import cancel from "../../../picture/cancel.png";
import { GiDeliveryDrone } from "react-icons/gi";
import { MdDateRange } from "react-icons/md";
import edits from "../../../picture/edit.gif";
import { MdOutlinePayments } from "react-icons/md";
import docgif from "../../../picture/investigation.gif";
import { TbDrone } from "react-icons/tb";
import { MdSettingsRemote } from "react-icons/md";

//react-bootsrap
import { OverlayTrigger, Tooltip } from "react-bootstrap";

//Prime
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { useLanguage } from "../../../Language/LanguageContext";
import Drone_Status_Regulator from "../../../Style_Component/Steps/User_Drone_Status";


export default function DroneList(props) {
  let Navigate = useNavigate();
  const [ShowPayment, setShowPayment] = useState(false);
  const [droneidPay, setdroneidPay] = useState("");
  const { t, changeLanguage, language, fontFamily } = useLanguage();

  function EditRegis() {
    Navigate("/profile/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }
  const getdatadrone = (req_num, status1) => {
    Navigate("/user/drone/datadrone", {
      state: {
        drone_id: req_num,
        status: status1,
        href: window.location.pathname // can i use window.location.href ?
      },
    });
  };

  //config mui lib 
  const [globalFilter, setGlobalFilter] = useState(null);

  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <h4 className="m-0"> </h4>
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const header = renderHeader();
  function filtered_Drone(data) {
    const filteredData = data.filter(
      (item) =>
        item.brand_model
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.drone_req_num
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.registration_date
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join(""))
    );
    return filteredData;
  }

  //body 
  const Body_number = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <MdDateRange /> */}
        <div style={{ marginLeft: "2px" }}> {data.drone_req_num}</div>
        {/* <div style={{ marginLeft: "2px" }}>   {`${data.registration_date.substring(0, 10)}` + " " + `${data.registration_date.substring(11, 16)}`}</div> */}
      </div>
    );
  };
  const Body_Regist_Date = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <MdDateRange />
        {/* <div style={{ marginLeft: "2px" }}> {data.drone_req_num}</div> */}
        <div style={{ marginLeft: "2px" }}>
          {" "}
          {`${data.registration_date.substring(0, 10)}` +
            " " +
            `${data.registration_date.substring(11, 16)}`}
        </div>
      </div>
    );
  };

  const Body_owner_brand = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>
          {/* <FaUserAstronaut />  {data.owner} */}
          {/* <br /> */}
          <GiDeliveryDrone /> {data.brand_model}
        </div>
      </div>
    );
  };
  const Body_Status = (data) => {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        <Drone_Status_Regulator status={data.regis_status_text} />
        {/* <Regulator_Status status={data.caat} style={{width:"80%"}}/> */}
      </div>
    );
  };
  const Body_payment = (data) => {
    return (
      <div>
        {data.regis_status_text === "ชำระค่าพิจารณาคำขอ" ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              setdroneidPay(data.drone_id);
              setShowPayment(true);
            }}
          >
            <MdOutlinePayments
              style={{ color: "green", width: "30px", height: "30px" }}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };
  const Body_Information = (data) => {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        {(data.connect_rid === 1 && data.regis_status_text != "-") ||
          (data.connect_rid != 1 && data.regis_status_text != "-") ? (
          <>
            <>
              <a
                className="custom-link"
                onClick={() => {
                  getdatadrone(
                    data.drone_id,
                    data.regis_status_text,
                    data.caat_comment,
                    data.nbtc_comment
                  );
                }}
              >
                {data.regis_status_text === "รอแก้ไข" ||
                  data.regis_status_text === "ร่างเอกสาร" ? (
                  <OverlayTrigger
                    placement="top" // You can adjust the placement: "top", "right", "bottom", "left"
                    overlay={<Tooltip id="edit doc">Edit</Tooltip>}
                  >
                    <div>
                      <img
                        alt="edit"
                        src={edits}
                        style={{ height: "36px", width: "36px" }}
                      />
                      <sup
                        style={{
                          color: "red",
                          top: "-10px",
                          right: "5px",
                          fontSize: "16px",
                        }}
                      >
                        !
                      </sup>
                    </div>
                  </OverlayTrigger>
                ) : (
                  <img
                    alt="edit"
                    src={docgif}
                    style={{ height: "36px", width: "36px" }}
                  />
                )}
              </a>
            </>
          </>
        ) : (
          <img
            alt="cancle"
            src={cancel}
            style={{ height: "36px", width: "36px" }}
          ></img>
        )}
      </div>
    );
  };
  const sortOrder = [
    "รอแก้ไข",
    "ชำระค่าพิจารณาคำขอ",
    "ตรวจสอบการชำระเงิน",
    "อยู่ระหว่างพิจารณา",
    "อนุมัติ",
  ];
  const customSort = (event) => {
    const value = [...event.data]; // Clone the array to avoid modifying the original data
    value.sort((a, b) => {
      const value1 = a[event.field];
      const value2 = b[event.field];
      console.log(value2);
      const index1 = sortOrder.indexOf(value1);
      const index2 = sortOrder.indexOf(value2);

      return (index1 - index2) * event.order;
    });
    return value;
  };
  console.log(props);
  return (
    <>
      <h2 className="profile-header">โดรนในครอบครอง</h2>
      <div className="user-main">
        {/* <div className="container-main" style={{ margin: 0, width: "auto", minHeight: 600, maxHeight: 600 }}> */}
          <DataTable
            value={globalFilter ? filtered_Drone(props.dronedata) : props.dronedata}
            paginator
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rows={5}
            rowsPerPageOptions={[5]}
            header={header}
            emptyMessage="ไม่มีข้อมูล"
            tableStyle={{ minWidth: "50rem"}}
            style={{ fontFamily: "Kanit" }}
          >
            <Column
              header={t('statusdrone.number')}
              body={Body_number}
              field={`drone_req_num`}
              sortable
              filterField="drone_req_num"
              dataType="date"
              bodyStyle={{ alignItems: "center", textAlign: "center" }}
              style={{ width: "14%" }}
            ></Column>
            <Column
              header={t('statusdrone.brandmodel')}
              body={Body_owner_brand}
              field={"owner" && "brand_model"}
              sortable
              bodyStyle={{ alignItems: "center", textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>

            <Column
              header={t('statusdrone.status')}
              body={Body_Status}
              field="regis_status_text"
              sortable
              sortFunction={customSort}
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('statusdrone.dateregis')}
              body={Body_Regist_Date}
              field={`registration_date`}
              sortable
              filterField="registration_date"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "14%" }}
            ></Column>
     

            {/* <Column
              header={t('statusdrone.checkdata')}
              field={"connect_rid"}
              body={Body_Information}
              sortable
              sortFunction={customSort}
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "12%" }}
            ></Column>
            <Column
              header={t('statusdrone.payservice')}
              //field={"connect_rid"}
              body={Body_payment}
              //sortable
              //sortFunction={customSort}
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "11%" }}
            ></Column> */}
          </DataTable>
        {/* </div> */}
      </div>



    </>
  );
};

